<template>
  <div>
    <h1 style="margin-top: 60px; margin-bottom: 30px">Privacy Policy</h1>
    <div class="corner">
      <div class="content">
        <br/>
        <strong>App:</strong> NotiShare
        <br/>
        <strong>Effective date:</strong> June 13, 2026
        <br/>
        <br/>

        <strong>What NotiShare Does</strong>
        <br/>
        NotiShare forwards notifications from your device to your own paired device(s). It uses Android’s Notification Listener permission to detect notifications, then relays them to the device(s) you have paired.
        <br/>
        <br/>

        <strong>Notification Content</strong>
        <br/>
        Notification content is end-to-end encrypted on your device before it leaves. Our relay server only routes the encrypted payload to your paired device and cannot read it. The content is not stored: it is discarded immediately after delivery (or after a short delivery-retry window) and is never logged or used for any other purpose.
        <br/>
        <br/>

        <strong>Information We Collect</strong>
        <br/>
        Hashed Device ID only. We generate a one-way hashed identifier (“Hashed ID”) by combining the Android ID with an app-specific key (salt) and applying a one-way hash, and a push (FCM) token. These are used solely to pair your devices and route relayed notifications to the correct target device.
        <br/>
        We do not collect or store the raw Android ID, names, emails, precise location, contacts, photos, or the content of your notifications.
        <br/>
        <br/>

        <strong>How We Use This Data</strong>
        <br/>
        App functionality: Pair your devices and deliver relayed notifications between them.
        <br/>
        Security &amp; fraud prevention: Detect misuse, spam, or unauthorized activity.
        <br/>
        We do not sell data and do not use it for cross-app tracking.
        <br/>
        <br/>

        <strong>Advertising</strong>
        <br/>
        The app shows ads provided by Google AdMob. Google may use an advertising identifier to serve and measure ads. See Google’s Privacy Policy for details.
        <br/>
        <br/>

        <strong>Sharing</strong>
        <br/>
        We do not share personal data with third parties, except trusted service providers (e.g., cloud hosting and push delivery via Firebase Cloud Messaging) that process it on our behalf under confidentiality and security obligations. Relayed notification content is delivered only to your own paired device(s), end-to-end encrypted.
        <br/>
        <br/>

        <strong>Retention &amp; Deletion</strong>
        <br/>
        Notification content is not retained. Pairing data (Hashed ID and push token) is kept only as long as the pairing is active and deleted when you unpair or uninstall.
        <br/>
        <br/>

        <strong>Security</strong>
        <br/>
        We use end-to-end encryption for notification content, encryption in transit and at rest for pairing data, access controls, and one-way hashing with a private key/salt.
        <br/>
        <br/>

        <strong>International Transfers</strong>
        <br/>
        Data may be processed on servers outside your country. We protect it as described in this policy.
        <br/>
        <br/>

        <strong>Changes</strong>
        <br/>
        We may update this policy and will post the new version with a new effective date.
        <br/>
        <br/>

        <strong>Contact</strong>
        <br/>
        evidence.erae@gmail.com
        <br/>
        <br/>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HelloWorld',
  data() {
    return {}
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.corner {
  margin: 30px;
  border-radius: 10px;
  border: 2px solid #ffffff;
  background-color: #ffffff;
  padding: 10px;
  text-align: left;
}

.content {
  padding: 0 0 0 10px;
  margin: 0 0;
  text-align: left;
}

h1 {
  text-align: center;
}

h2 {
  text-align: left;
  font-size: 13px;
  color: #aaaaaa;
  padding-bottom: 15px;
}

h3 {
  text-align: center;
  margin: 3px 0 0;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
}

</style>
